export enum PostOrder
{
    desc = 'desc',
    asc = 'asc'
}